class CartNotice extends HTMLElement {
  constructor () {
    super ()
    this.dialog = this.querySelector('[data-cart-notice-el="dialog"]');
    this.counter = this.querySelector('[data-cart-notice-el="counter"]');
    this.productContainer = this.querySelector('[data-cart-notice-el="product"]');
    this.viewBagCta = this.querySelector('[data-cart-notice-el="viewBag"]');
    this.closeCta = this.querySelector('[data-cart-notice-el="closeDialog"]');
    this.backdrop = this.querySelector('[data-cart-notice-el="backdrop"]');
    this.cartDrawer = document.querySelector('cart-drawer');
  }

  cartUpdateUnsubscriber = undefined;

  connectedCallback () {
    this.setupListeners()
    this.setupEventListeners()
  }

  setupListeners() {
     this.closeCta.addEventListener('click', () => {
      this.closeDialog();
    })

    this.backdrop.addEventListener('click', () => {
      this.closeDialog();
    })

    this.viewBagCta.addEventListener('click', () => {
      this.closeDialog();

      setTimeout(() => {
        this.cartDrawer.open()
      }, 300);
    })
  }

  setupEventListeners() {
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event.source === 'product-form' || event.source === undefined) {
        this.triggerDialog(event)
      }
    });
  }

  async triggerDialog(event) {
    const data = event.cartData.items ? event.cartData.items[0] : event.cartData;

    if (data) {
      const priceHTML = await this.fetchProductPrice(data.handle);

      this.populateDialogData(data, priceHTML)

      const cart = await fetch(`${window.Shopify.routes.root}cart.js?no-cache=${new Date().getTime()}`, {
        credentials: 'same-origin',
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      }).then((response) => {
        return response.json();
      });

      this.counter.innerHTML = `(${cart.item_count})`;
      this.openDialog()
    }
  }

  populateDialogData(data, priceHTML) {
    this.productContainer.innerHTML = this.getLineItem(data, priceHTML);
  }

  getLineItem(data, priceHTML) {
    return `
      <div class="cart-notice__product-image">
        <img
          alt="${data.product_title}"
          src="${data.image}&width=200"
        >
      </div>

      <div class="cart-notice__product-desc">
        <a class="cart-notice__product-title" href="${data.url}">
          ${data.product_title}
        </a>

        <div class="cart-notice__product-price">
          ${priceHTML}
        </div>

        <p class="cart-notice__product-variant-title">
          ${data.gift_card
            ? `${data.variant_options[0]}`
            : `${window.theme.strings.cart.notice.size}: ${data.variant_options[0]}`
          }
        </p>
      </div>
    `
  }

  async fetchProductPrice(handle) {
    const fetchUrl = `${window.Shopify.routes.root}products/${handle}?section_id=cart-notice-price`;

    const response = await fetch(fetchUrl);
    const text = await response.text();

    const parser = new DOMParser();
    const doc = parser.parseFromString(text, 'text/html');

    return doc.querySelector('.shopify-section').innerHTML;
  }

  openDialog() {
    this.dialog.setAttribute('open', '');
    document.body.classList.add('overflow-hidden');
  }

  closeDialog() {
    this.dialog.removeAttribute('open');
    this.productContainer.innerHTML = '';
    document.body.classList.remove('overflow-hidden');
  }
}

customElements.define('cart-notice', CartNotice)